<template>
  <!--  -->
  <div
    ref="rename"
    class="rename-section"
  >
    <!-- 正常显示span -->
    <!-- <co-tips :content="'点击可重命名'" v-if="!isRename">
            <span class="re-title"  @click="rename">{{name}}</span>
        </co-tips> -->
    <el-tooltip
      class="re-title-tip"
      effect="dark"
      :content="name"
    >
      <span
        class="re-title"
        @click="rename"
      >{{ name }}</span>
    </el-tooltip>

    <!-- 点击显示编辑组 -->
    <div
      v-show="isRename"
      class="change-title"
    >
      <div class="edit-border">
        <!-- 输入框 -->
        <input
          ref="reInput"
          v-model="reTitle"
          type="text"
          class="title-input"
          :style="{width:width + 'px'}"
          @keyup.enter="finish"
          @keyup="ctrlz"
        >
        <!-- 叉勾按钮组 -->
        <div class="button-group">
          <!-- 对号 -->
          <span
            class="re-icon"
            @click="finish"
          >
            <svg>
              <use xlink:href="#sure" />
            </svg>
          </span>
          <!-- 叉 -->
          <span
            class="re-icon"
            @mousedown="reverse"
          >
            <svg>
              <use xlink:href="#close" />
            </svg>
          </span>
        </div>
      </div>
    </div>
    <!-- 修改扩展名弹框 -->
    <co-toast
      v-model="isToast"
      :is-auto="true"
      :is-link="false"
      :toast-info="toastContent"
    />
  </div>
</template>
<script>
/*
 * @Author: lisiyi
 * @Date: 2019-12-18 17:00
 * @Last Modified by: lisiyi
 * @Last Modified time: 2019-12-18 17:00
 */
import coToast from 'components/common/toast/index.vue'
import coTips from 'components/common/tips/index.vue'
import * as Util from 'js/util/util'
import _$ from 'js/api/getdata.js'

export default {
  components: {
    coToast,
    coTips,
  },
  props: {
    // 文件信息
    fileData: {
      type: Object,
      default: () => ({}),
    },
    showRename: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileExtension: '', // 文件扩展名
      isRename: false, // 是否编辑状态位
      name: '', // span内文件名
      fileName: '', // 真实文件名（不包括扩展名）
      isSelected: false, // 名字进入编辑状态是否被选中
      reTitle: '', // input框内文字
      isToast: false, // toast显隐
      toastContent: {
        info: '',
        tipsType: 'warn',
      }, // toast内容
      width: 408, // input 宽度
      distance: 20, // 间距
    }
  },
  watch: {
    /**
             * 编辑状态时时注册全局的click事件
             * 当下拉菜单收起时取消全局的click事件
             */
    isRename(n) {
      const iframe = document.getElementById('pdfframe')
      if (n) {
        this.changeWidth()
        document.addEventListener('click', this.otherClick)
        // 可传一个函数来注册iframe的点击事件
        // 目前预览页面会有一个iframe所以加到组件里
        if (iframe && iframe.contentDocument) {
          iframe.contentDocument.addEventListener('click', this.otherClick)
        }
        return
      }
      document.removeEventListener('click', this.otherClick)
      if (iframe && iframe.contentDocument) {
        iframe.contentDocument.removeEventListener('click', this.otherClick)
      }
    },
    name(n, o) {
      this.fileName = n.replace(/(.*\/)*([^.]+).*/ig, '$2') // 监听文件名,如果改变则真实文件名也改变
      if (n.lastIndexOf('.') !== -1) { // 获取扩展名
        this.fileExtension = n.substring(n.lastIndexOf('.') + 1)
      } else {
        this.fileExtension = ''
      }
    },
    // 监听filedata，如果新值为空，则名字不变
    fileData: {
      handler(n, o) {
        console.log(n)
        if (Object.keys(n).length === 0) {
          this.name = o.path.split('/').pop()
        } else {
          this.name = n.path.split('/').pop()
        }
      },
      deep: true,
    },
  },
  mounted() {
    window.addEventListener('resize', this.throttle(this.changeWidth, 50))
  },
  updated() {
    if (this.isSelected) { // 组件更新时将input框内文字变为选中状态
      this.$refs.reInput.focus() // input焦点
      this.$refs.reInput.setSelectionRange(0, this.fileName.length) // 文字选中区域
      this.isSelected = false // 状态位恢复，防止数据更新
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.changeWidth)
  },
  created() {
    // 组件创建时判断父组件传来的filedata是否为空，如果为空将名字赋空，如果不为空，证明父组件数据已经请求回来，直接赋值
    if (Object.keys(this.fileData).length === 0) {
      this.name = ''
    } else {
      this.name = this.fileData.path.split('/').pop()
    }
  },
  methods: {
    /**
        * 撤销
        */
    ctrlz(e) {
      if ((e.key === 'z' && e.ctrlKey === true) || (e.key === 'z' && e.metaKey === true)) { // ctrl+z 或者 command+z
        this.$refs.reInput.focus() // 获取焦点
        this.$refs.reInput.setSelectionRange(0, this.reTitle.length) // 选中文字部分
      }
    },
    /**
        * 节流函数
        */
    throttle(fn, delay) {
      let timer = null
      return function () {
        clearTimeout(timer)
        timer = setTimeout(() => {
          fn()
        }, delay)
      }
    },
    /**
            * 点击空白处
            */
    otherClick(e) {
      const { rename } = this.$refs
      if (rename.contains(e.target)) {
        return
      }
      this.isRename = false
      this.$emit('finish', false)
    },
    /**
            * 取消编辑事件
            */
    reverse() {
      this.isRename = false // 显示span
      this.$emit('finish', false)
    },
    /**
            * 点击重命名
            */
    rename() {
      this.reTitle = this.fileName // span文本赋值给input框内文本
      if (!this.showRename) {
        return
      }
      this.isRename = true // 显示input
      this.$emit('rename', true) // 抛出事件
      this.isSelected = true // input框内文字选中状态位
    },
    /**
            * 重命名完成，调接口
            */
    finish() {
      if (this.fileName === this.reTitle) { // 如果文件名未改变则退出编辑状态
        this.isRename = false
      } else if (this.check(this.reTitle)) { // 判断重命名是否符合规范
        // 重命名接口
        const info = JSON.stringify({ op_info: { neid: this.fileData.neid }, fileName: `${this.reTitle}.${this.fileExtension}` })
        const data = {
          op: 'rename',
          ignore_share: false,
          auto_rename: false,
          info,
          arrayFormat: true,
        }
        _$.postData('fileOp', data)
          .then((res) => {
            this.$emit('afterRename', this.reTitle)
            this.name = `${this.reTitle}.${this.fileExtension}` // 如果接口成功，将span内文字修改
            this.isRename = false // 结束编辑状态
            this.toastContent.info = this.$t('重命名成功')
            this.toastContent.tipsType = 'success'
            this.isToast = true
            this.$emit('finish', false)
          }).catch((error) => {
            const err = error.response.data
            if (err.state === 409) { // 文件重名
              this.toastContent.info = this.$t('已存在同名文件，请重新输入')
              this.toastContent.tipsType = 'warn'
              this.isToast = true // 显示toast
              this.$refs.reInput.focus() // 获取焦点
              this.$refs.reInput.setSelectionRange(0, this.reTitle.length) // 选中名称部分
              this.$emit('repeat')
            }
          })
      }
    },
    /**
            * 文件名校验
            */
    check(name) {
      if (!Util.validEmpty(name)) { // 判断文件名是否为空    //此处应为tips
        this.toastContent.info = this.$t('名称不能为空')
        this.toastContent.tipsType = 'warn'
        this.isToast = true
        return false
      } if (!Util.validFilename(name)) { // 校验文件名内字符
        this.toastContent.info = `${this.$t('文件名称不能包括下列任何字符')}: \\/:*?"<>|`
        this.toastContent.tipsType = 'warn'
        this.isToast = true
        return false
      }
      return true
    },
    /**
        * 修改宽度
        */
    changeWidth() {
      const { rename } = this.$refs // 获取rename
      const btngroup = document.getElementById('btngroup') // 获取按钮组件
      if (btngroup && rename) {
        this.$nextTick(function () {
          // let btnWidth = window.innerWidth - btngroup.getBoundingClientRect().left      //按钮宽度
          // let rightDistance = window.innerWidth - rename.getBoundingClientRect().right    //rename右侧距离
          // let leftDistance = rename.getBoundingClientRect().left     //rename左侧距离
          // if (window.innerWidth >= 1024 && rightDistance < btnWidth + this.distance) {     //当屏幕宽度大于等于1024 且右侧距离不足以放下按钮组时
          //     this.width = window.innerWidth - leftDistance - (btnWidth + this.distance) - 83     //宽度随屏幕宽度变化而变化
          // } else if (window.innerWidth > 1024 && rightDistance >= btnWidth + this.distance) {     //当屏幕宽度大于1024  且右侧足以放下按钮组，宽度保持408
          //     this.width = 408;
          // }
          document.querySelector('.change-title').style.width = `${btngroup.getBoundingClientRect().left - 104}px`
          if (window.innerWidth <= 1080) {
            this.width = 354
          } else {
            this.width = 408
          }
        })
      }
    },
  },
}
</script>
<style lang="less" scoped>
svg:first-child{
  width: 17px;
  height:12px;
  margin-bottom:-2px;
}
input{
  outline:none;
}
.rename-section{
  display: inline-block;
  max-width: 450px;
  /**标题样式超过一定字段... */
  .re-title {
    width:100%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    display: inline-block;
  }
}

.edit-border{
  display: inline-block;
  height: 30px;
  line-height: 30px;
  border: 1px solid #0A64FA;
  border-radius: 2px;
  position: relative;
}

.title-input{
  display: inline-block;
  border:none;
  padding-left:12px;
}
.button-group{
  margin:0 8px;
  display:inline-block;

}
.re-icon{
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
}
.re-icon:hover{
  background-color: rgb(246, 247, 250)
}


</style>
